import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes} from 'react-icons/fa';
import NavBar from './NavBar';
import { Link, useLocation } from 'react-router-dom';
import './ChinaFocus.css';
import imageChina from './assets/images/China-page-merger-image.png';

import logo1 from './assets/images/0040C0.png';
import logo from './assets/images/favicon1.webp';

const ChinaFocus = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
          document.title = "China Focus – Bay Capital Advisors";
          
          // Find and update the favicon
          let favicon = document.querySelector("link[rel~='icon']");
          if (!favicon) {
            favicon = document.createElement('link');
            favicon.rel = 'icon';
            document.head.appendChild(favicon);
          }
          favicon.href = logo; // Use your logo as favicon
          
          return () => {
            // Reset title when component unmounts if needed
            document.title = "Bay Capital Advisors";
          };
        }, []);
        
          const toggleMobileMenu = () => {
            setIsMobileMenuOpen(!isMobileMenuOpen);
          };
        
          const closeMobileMenu = () => {
            setIsMobileMenuOpen(false);
          };
    const [expandedSection, setExpandedSection] = useState(null);

  const toggleSection = (section) => {
    setExpandedSection((prevSection) => (prevSection === section ? null : section));
  };
  return (
    <div className="china-focus-page">
      <div className="mobile-menu-button" onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
      </div>
      
      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="mobile-dropdown-overlay" onClick={closeMobileMenu}>
          <div className="mobile-dropdown" onClick={(e) => e.stopPropagation()}>
            <NavBar isMobile={true} closeMenu={closeMobileMenu} />
          </div>
        </div>
      )}
        <section class="hero3">
    
        <div class="header-overlay-c"></div>
    
    <header class="header3">
    <NavBar />
  </header>
        
        <header className="china-focus-header">
        
          <h1>CHINA FOCUS</h1>
        
      </header>
      </section>

      <div className="china-content">
        <div className="text-column_c">
          <p>
            The remarkable economic expansion of China continues to generate outstanding performances despite slower growth around the rest of the globe. If the year-end 2018 results are any indication, the long-term outlook should be equally compelling over the next two decades. The fact is that it is one of only two countries today that have higher growth, larger capital gains, and more opportunities to make money, the other being India. The following growth rates highlight a trend where, in less than two decades, China is already the second largest economic power in the world – and only truly beginning to rise and exert its influence around the globe with various economic, trade, and military initiatives:
          </p>
          <div className="china-image">
            <img src={imageChina} alt="China Focus" />
        </div>
        </div>

        <div className="points-column">
          <ul style={{ listStyleType: "circle", paddingLeft: "25px" }}>
            <li>
              
              <p><strong>One of the world's Highest GDP growth</strong> – averaging over 7% annual growth – 5 consecutive years as the world leader;</p>
            </li>
            <li>
             
              <p><strong>Sustainable Growth</strong> – Strong forecasted GDP averaging over 6.5% through 2018;</p>
            </li>
            <li>
              
              <p><strong>World's Largest Market</strong> – 1.4 billion people with rapidly rising disposable income, a middle class of over 300 million people;</p>
            </li>
            <li>
              
              <p><strong>Sustained Consumer Boom</strong> – Despite being only in its infancy stage, China consumerism will explode as a population of 300 million (a mere tip of the iceberg) with minimum per capita incomes exceeding $10,000 seeks to upscale lifestyles;</p>
            </li>
            <li>
              
              <p><strong>Removal of Protectionist Barriers</strong> –  China’s 2001 entry into the WTO dramatically cuts import barriers previously imposed on American and European products and services and provides international investors and corporations increasing access to virtually every economic sector, including markets for agriculture, services, technology, telecommunications, financial services, manufactured goods, pharmaceuticals and healthcare. The world has become reliant on China for its manufacturing capabilities and will continue to rely on it moving into the future, regardless of protectionist sentiments in many countries around the world.</p>
            </li>
          </ul>
        </div>
      </div>

      <div className="china-focus-div">
        <section className="china-focus-body">
            <h2 className="china-focus-title">THE OPPORTUNITY</h2>
            <p className="china-focus-description">
            What does the future hold for economic opportunity in China? Certainly, China WTO membership is the catalyst igniting its role in reaccelerating global capitalism. Overnight, a floodgate opened for foreign companies eagerly rushing to establish brand recognition, distribution, and local manufacturing ability within the PRC borders. The stakes are without historical precedent in terms of sheer scale of the overall opportunity. Even the specter of an international war has not diminished, but only served as further enticement in differentiating and attracting new investment into an economy not roiled with uncertainty as the US. Businesses claiming first-mover advantage in China will possess enormous competitive advantages, including: sizeable cost savings; wider profit margins; efficient and highly motivated labor; state-of-the-art world class manufacturing centers; government subsidized programs to attract business relocation, and; the ability to reach the fastest growing – and ultimately the largest by a considerable magnitude – consumer market in the world. 
            </p>
        </section>
      </div>

      {/* Accordion Sections */}
      <div className="accordion-section">
  <div className="accordion-item">
    <h3
      onClick={() => toggleSection('investmentBackground')}
      className="accordion-header"
      style={{ fontSize: '1.1rem', display: 'flex', alignItems: 'center', gap: '8px' }}
    >
      <span style={{ fontSize: '1.7rem' }}>{expandedSection === 'investmentBackground' ? '−' : '+'}</span>
      Investment Background
    </h3>
    <div className={`accordion-content ${expandedSection === 'investmentBackground' ? 'expanded' : ''}`}>
    <p>
                {/* Investment Background content */}
                It is important to understand the context and perspective in assessing the situation.  In the financial sectors, China has expanded the scope and geographic opportunities for foreign banks to conduct local currency business since WTO admission. Foreign broker-dealers can now deal directly in “B shares” (without any Chinese intermediary) and are eligible for “special” membership in all exchanges. Foreign financial institutions are allowed to establish securities operation as a joint venture with a minority (up to or equal to 33.33%) equity share to underwrite A, B, and H shares and corporate and government debt and trade all these securities except A shares by 3 years after the WTO entry date of December 11, 2001. Foreign financial institutions are also allowed to manage assets in China through a joint venture with minority equity share (one-third equity share cap upon accession, 49 percent by three years after accession). The restrictions for the provision of financial information, data processing and advisory services (such as portfolio research and corporate restructuring) have been removed upon accession.
                </p>
                <p>
                Historically, foreign investment was primarily limited to direct investment, B shares stocks listed on Shanghai or Shenzhen stock exchanges, or “China plays” stocks listed on the Hong Kong Stock Exchange and US stock exchanges. Since 1993, China has absorbed over US$1.5 trillion foreign investment. Investments are made in old line businesses, “green field” projects and increasingly in the technology industry.  According to statistics, over 60% of cross-border investments in the world are made through M&A transactions. WTO membership and relaxed economic policies guarantees the removal of most regulatory barriers for cross border M&A into China. M&A will provide a more accelerated and cost-efficient method for foreign companies to enter China.  However, we recommend moving into China with a reputable and capable partner and team on the ground.
                </p>
    </div>
  </div>

  <div className="accordion-item">
    <h3
      onClick={() => toggleSection('theChallenge')}
      className="accordion-header"
      style={{ fontSize: '1.1rem', display: 'flex', alignItems: 'center', gap: '8px' }}
    >
      <span style={{ fontSize: '1.7rem' }}>{expandedSection === 'theChallenge' ? '−' : '+'}</span>
      The Challenge
    </h3>
    <div className={`accordion-content ${expandedSection === 'theChallenge' ? 'expanded' : ''}`}>
    <p>
                {/* The Challenge content */}
                Foreign investors and companies are no longer wrestling with whether to invest in China, but rather, how best to approach it. To outsiders, the Chinese system appears a complex maze, with areas of multiple overlap and a structure that is difficult to decipher. In fact, the China structure is highly sophisticated and organized – only different. Foreign companies often lack China sophistication and an understanding of Chinese business methods and regulatory structure.
                </p>
                <p>
                On the other hand, Chinese companies are reaching out to the West for financial and corporate partnership. However, attracting western corporate partnership and investment are not simple tasks. The typical Chinese company lacks the intimate knowledge of western business nuance and Chinese administrative management often lacks western experience and expertise. Success requires that China opportunities be adapted according to western methods.
                </p>
                <p>
                The demographic shifts and types of investment have further altered the way Chinese investors manage their personal financial assets. The Asia-Pacific region presents a promising market for capital management especially in Great China Area. The recent volatility in the world financial markets has increased the demand for reliable, steady year return capital management. With WTO opens doors for China and Taiwan, Asia’s retail and institutional investors have increasingly looked beyond local stock exchanges to invest in well-established U.S. markets.
              </p>
    </div>
  </div>
</div>
    <div className="concluding-section-div">
        <section className="concluding-section">
    <p>
        Many companies are preparing to explore all of these China related opportunities. However, achieving success requires strategies that combine expert understanding of both Chinese and western systems, experience in cross-border transactions, and an infrastructure to support the transactions.
    </p>
    </section>
    </div>
     {/* Footer Section */}
     <div className="footer-section">
        <nav>
          <a href="/CoreValues">Core Values</a>
          <a href="/Resources">Resources</a>
          <a href="/ContactUs">Contact Us</a>
        </nav>
        <div className="footer-logo">
                <Link to="/"> {/* Add this Link wrapper */}
                  <img src={logo1} alt="Bay Capital Advisors Logo" className="logo" />
                </Link>
                </div>
        <nav>
          <a href="/PrivacyPolicy">Privacy Policy</a>
          <a href="/TermsOfService">Terms of Service</a>
        </nav>
      </div>

    </div>
  );
};

export default ChinaFocus;
